/**
 * Header component
 */

export const Header = {
    /** @type {JQuery<HTMLElement> | null} */
    $el: null,

    getEl: () => {
        if (!Header.$el) Header.$el = $('#header');

        return Header.$el;
    },

    /**
     * Get the height of the header (including contact bar)
     *
     * @returns {string}
     */
    getHeight: () => $('#banner').offset().top.toFixed(0),

    getFixedPosition: () => $(window).height() / 2,
};

function showFixedHeader() {
    const scrolledTop = $(document).scrollTop();
    const $header = Header.getEl();

    $header.css('--header-height', Header.getHeight() + 'px');

    if (scrolledTop > Header.getHeight()) {
        $header.addClass('sticky');
    } else {
        $header.removeClass('sticky');
    }

    if (scrolledTop > Header.getHeight()) {
        $header.addClass('show');
    } else {
        $header.removeClass('show');
    }
}

$(function () {
    showFixedHeader();
});

$(window).on('scroll resize', function () {
    showFixedHeader();
});
